import Pusher from 'pusher-js';
import apiService from '../apiService';

let pusherClient = null;

const PUSHER_APP_KEY = process.env.REACT_APP_PUSHER_APP_KEY || '';
const PUSHER_CLUSTER = process.env.REACT_APP_PUSHER_APP_CLUSTER || 'mt1';
const PUSHER_HOST = process.env.REACT_APP_PUSHER_HOST || '';
const PUSHER_PORT = Number(process.env.REACT_APP_PUSHER_PORT || 443);
const PUSHER_SCHEME = process.env.REACT_APP_PUSHER_SCHEME || 'https';

const isRealtimeEnabled = () => {
  return Boolean(PUSHER_APP_KEY);
};

const getAuthHeaders = () => {
  const token = apiService.getToken();
  if (!token) {
    return {};
  }

  return {
    Authorization: `Bearer ${token}`,
  };
};

const getPusherClient = () => {
  if (!isRealtimeEnabled()) {
    return null;
  }

  if (pusherClient) {
    pusherClient.config.auth = {
      ...(pusherClient.config.auth || {}),
      headers: getAuthHeaders(),
    };
    return pusherClient;
  }

  const useTLS = PUSHER_SCHEME === 'https';
  const options = {
    cluster: PUSHER_CLUSTER,
    forceTLS: useTLS,
    authEndpoint: `${apiService.baseURL}/broadcasting/auth`,
    auth: {
      headers: getAuthHeaders(),
    },
    enabledTransports: ['ws', 'wss'],
  };

  if (PUSHER_HOST) {
    options.wsHost = PUSHER_HOST;
    options.httpHost = PUSHER_HOST;
    options.wsPort = PUSHER_PORT;
    options.wssPort = PUSHER_PORT;
  }

  pusherClient = new Pusher(PUSHER_APP_KEY, options);

  return pusherClient;
};

export const subscribeToUserNotifications = (userId, onEvent) => {
  const numericUserId = Number(userId);
  if (!Number.isFinite(numericUserId) || numericUserId <= 0 || typeof onEvent !== 'function') {
    return () => {};
  }

  const client = getPusherClient();
  if (!client) {
    return () => {};
  }

  const channelName = `private-notifications.user.${numericUserId}`;
  const channel = client.subscribe(channelName);

  const handler = (payload) => {
    const notification = payload?.notification || payload;
    if (notification) {
      onEvent(notification);
    }
  };

  channel.bind('notification.created', handler);

  return () => {
    channel.unbind('notification.created', handler);
    client.unsubscribe(channelName);
  };
};

export const subscribeToPromotions = (onEvent) => {
  if (typeof onEvent !== 'function') return () => {};

  const client = getPusherClient();
  if (!client) return () => {};

  const channel = client.subscribe('promotions');
  const handler = (payload) => {
    if (payload) onEvent(payload);
  };

  channel.bind('promotion.broadcast', handler);

  return () => {
    channel.unbind('promotion.broadcast', handler);
    client.unsubscribe('promotions');
  };
};

export const subscribeToAppUpdates = (onEvent) => {
  if (typeof onEvent !== 'function') return () => {};

  const client = getPusherClient();
  if (!client) return () => {};

  const channel = client.subscribe('app-updates');
  const handler = (payload) => {
    if (payload) onEvent(payload);
  };

  channel.bind('app.updated', handler);

  return () => {
    channel.unbind('app.updated', handler);
    client.unsubscribe('app-updates');
  };
};
